import React from 'react'
import BlogPost from './BlogPost'

export default function ParadoxOfCloseness() {
  return (
    <BlogPost
      translationKey="paradoxOfCloseness"
      seoTitle="가까움의 역설 | Hyunjin Jae"
      seoDescription="가까워질수록 더 멀게 느껴지는 관계에 대한 짧은 생각입니다."
      seoKeywords="관계, 사랑, 가까움, 역설, relationship, love, closeness, paradox"
      seoTags={['relationship', 'love', 'reflection']}
    />
  )
}
